import type { ReactNode } from "react";

export interface ShellIconProps {
  size?: number;
  strokeWidth?: number;
}

export type ShellIcon = (props: ShellIconProps) => ReactNode;

export function PanelLeftOpenIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M9 3v18" />
      <path d="m14 9 3 3-3 3" />
    </Glyph>
  );
}

export function PanelLeftCloseIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M9 3v18" />
      <path d="m16 15-3-3 3-3" />
    </Glyph>
  );
}

export function PanelRightOpenIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M15 3v18" />
      <path d="m10 15-3-3 3-3" />
    </Glyph>
  );
}

export function PanelRightCloseIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M15 3v18" />
      <path d="m8 9 3 3-3 3" />
    </Glyph>
  );
}

export function ChatIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <path d="M5 5h14v10H9l-4 4z" />
    </Glyph>
  );
}

export function ChevronDownIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <path d="m6 9 6 6 6-6" />
    </Glyph>
  );
}

export function ChevronUpIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <path d="m6 15 6-6 6 6" />
    </Glyph>
  );
}

export function SearchIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m20 20-4-4" />
    </Glyph>
  );
}

export function UserIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1" />
    </Glyph>
  );
}

export function SettingsIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
    </Glyph>
  );
}

export function LogoutIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="m16 17 5-5-5-5M21 12H9" />
    </Glyph>
  );
}

export function HomeIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <path d="M4 11 12 4l8 7v8a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z" />
    </Glyph>
  );
}

export function ClientsIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <path d="M16 19v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1" />
      <circle cx="9" cy="7" r="3.5" />
      <path d="M22 19v-1a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </Glyph>
  );
}

export function DocumentsIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <path d="M7 3h7l5 5v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M14 3v5h5M9 13h6M9 17h6" />
    </Glyph>
  );
}

export function OrdersIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <path d="M9 5h11M9 12h11M9 19h11" />
      <path d="m3 5 1 1 2-2M3 12l1 1 2-2M3 19l1 1 2-2" />
    </Glyph>
  );
}

export function QuantIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <path d="M4 7h10M18 7h2M4 17h4M12 17h8" />
      <circle cx="16" cy="7" r="2" />
      <circle cx="10" cy="17" r="2" />
    </Glyph>
  );
}

export function AdminIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <circle cx="10" cy="8" r="3.5" />
      <path d="M3.5 20c.7-3.6 3.3-5.6 6.5-5.6 1 0 1.9.2 2.7.5" />
      <circle cx="17.5" cy="17.5" r="2" />
      <path d="M17.5 13.6v1.2M17.5 20.2v1.2M13.6 17.5h1.2M20.2 17.5h1.2M14.7 14.7l.9.9M19.4 19.4l.9.9M14.7 20.3l.9-.9M19.4 15.6l.9-.9" />
    </Glyph>
  );
}

export function FaIcon(props: ShellIconProps) {
  return (
    <Glyph {...props}>
      <path d="M3 21h18M5 21V10M9 21V10M15 21V10M19 21V10M2 10l10-6 10 6z" />
    </Glyph>
  );
}

function Glyph({
  size = 18,
  strokeWidth = 1.6,
  children,
}: ShellIconProps & { children: ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className="shrink-0"
    >
      {children}
    </svg>
  );
}
